import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import { risapi } from '../api/risapi';
import './LoginPage.css';

const LoginPage = () => {
    const [phone_number, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { user, login, isLoading: isAuthLoading } = useContext(AuthContext);
    const navigate = useNavigate();

    // This useEffect hook is the core of the fix.
    // It runs whenever the 'user' object from the context changes.
    useEffect(() => {
        if (user) {
            if (user.has_active_subscription) {
                navigate('/club_portal/dashboard');
            } else {
                navigate('/club_portal/select-plan');
            }
        }
    }, [user, navigate]);


    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setError('');

        try {
            const response = await risapi.post('/api/login', {
                phone_number,
                password,
            });

            if (response.status === 200 && response.data.access_token) {
                // Just call login. The useEffect will handle the redirect.
                login(response.data.access_token);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.message || 'An unexpected error occurred. Please try again.';
            setError(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isAuthLoading) {
         return (
            <div className='sign-in-bg d-flex justify-content-center align-items-center' style={{ minHeight: '100vh' }}>
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }


    return (
        <div className='sign-in-bg'>
            <div className="app-wrapper d-block">
                <div className="container main-container">
                    <div className="row main-content-box">
                        <div className="col-lg-7 image-content-box d-none d-lg-block">
                            <div className="form-container">
                                <div className="signup-content mt-4"><span>
                                    <img alt="Logo" className="img-fluid" style={{ maxWidth: "400px" }} src={process.env.REACT_APP_API_BASE_URL + '/logo_files/cricketmanagernewlogowithouttext.png'} />
                                    </span></div>
                                <div className="signup-bg-img"><img alt="Illustration" className="img-fluid" src={process.env.REACT_APP_API_BASE_URL + '/posters/2.png'} /></div>
                            </div>
                        </div>
                        <div className="col-lg-5 form-content-box">
                             
                            <div className="form-container">
                                <form onSubmit={handleSubmit} className="app-form">
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="mb-5 text-center text-lg-start">
                                                 {/* <img alt="Logo" className="img-fluid" style={{ maxWidth: "400px" }} src={process.env.REACT_APP_API_BASE_URL + '/logo_files/cricketmanagernewlogowithouttext.png'} /> */}
                                                <h2 className="text-white f-w-600">Welcome Back!</h2>
                                                <p className="f-s-16 mt-2">Sign in to manage your club.</p>
                                            </div>
                                        </div>
                                        {error && <div className="col-12 alert alert-danger">{error}</div>}
                                        <div className="col-12 form-floating mb-3">
                                            <input className="form-control" value={phone_number} onChange={(e) => setPhoneNumber(e.target.value)} placeholder="Phone Number" type="text" id="phoneNumber" />
                                            <label htmlFor="phoneNumber">Phone Number</label>
                                        </div>
                                        <div className="col-12 form-floating mb-3">
                                            <input className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" type="password" id="password" />
                                            <label htmlFor="password">Password</label>
                                        </div>
                                        <div className="col-12 mt-3">
                                            <button type='submit' className="btn btn-primary btn-lg w-100" disabled={isSubmitting}>
                                                {isSubmitting ? 'Signing In...' : 'Sign In'}
                                            </button>
                                        </div>
                                        <div className="col-12 mt-4">
                                            <div className="text-center text-lg-start f-w-500">
                                                Club Not yet Registered with us? 
                                                <Link to="/club_register" className="text-white-800 text-decoration-underline ms-1">Register Your Club Here</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;

